import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActionGridService } from '../action-grid.service';
import { FilterService } from 'src/app/services/filter.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-edit-grid-dialog',
  templateUrl: './edit-grid-dialog.component.html',
  styleUrls: ['./edit-grid-dialog.component.scss']
})
export class EditGridDialogComponent implements OnInit, OnDestroy {
  record: any = {};
  reqSubcription: Subscription[] = [];
  
  constructor(
    public dialogRef: MatDialogRef<EditGridDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private actionGridService: ActionGridService,
    private filterService: FilterService
  ) {}

  ngOnInit(): void {
    this.record = { ...this.data }; // Clone data to avoid direct mutation
  }

  onSave() {
    // if(!this.record.targetPayment || !this.record.filetype) return;

    // const targetPaymentStr = String(this.record.targetPayment);
    // if (targetPaymentStr.startsWith('0')) {
    //   this.record.targetPayment = targetPaymentStr.replace(/^0+/, '');
    // }

    let obj = {
      target_amount: this.record.targetPayment == 0 ? 0 : (Number(this.record.targetPayment) || 0),
      file_type: this.record.filetype || '',
      updated_by: this.filterService.baseQuery?.employee_key || undefined,
      pymt_calc_addn_file_type_key: this.record.pymt_calc_addn_file_type_key
    }
    let query = Object.assign({}, this.filterService.baseQuery, obj)
    this.reqSubcription.push(
      this.actionGridService.filetypeUpdateQuery(query).subscribe((res:any) => {
        let obj = Object.assign({}, this.record, { update: true })
        this.dialogRef.close(obj);
      }, err => {
        if(err.status==200) {
          let obj = Object.assign({}, this.record, { update: true })
          this.dialogRef.close(obj);
        }
      })
    )
  }

  onDelete() {
    this.dialogRef.close();
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.reqSubcription.forEach((res) => res.unsubscribe());
  }
}